module.exports = __webpack_public_path__ + "static/media/a8.4e5ce2f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lijunfeng/a8.mp3
// module id = SlZ+
// module chunks = 0